import { useEffect } from 'react'
import { useRouter } from 'next/router'

/**
 * Query flag saying "a registration number is already in the store, search on it".
 *
 * The plate itself is deliberately not in the url — it would end up in browser history,
 * referrer headers and any analytics that records paths.
 */
export const PLATE_SEARCH_FLAG = 'searchplate'

/**
 * Runs a plate search once, on arrival from a page that collected the number elsewhere,
 * then takes the flag back out of the url.
 *
 * @param search triggers the search; reads the plate from the store itself.
 */
export const usePlateSearchArrival = (search: () => void) => {
  const router = useRouter()
  const arrived = router.isReady && !!router.query[PLATE_SEARCH_FLAG]

  useEffect(() => {
    if (!arrived) return

    search()
    // asPath, not pathname: pathname is the internal route (/wheels), so replacing with it
    // would drop the visitor onto the English alias of the page they are already on.
    router.replace(router.asPath.split('?')[0], undefined, { shallow: true })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arrived])
}

export default usePlateSearchArrival
